import React from "react";
import MUIAlert, { AlertColor, AlertProps } from '@material-ui/core/Alert';

export type AlertType = AlertColor;

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
    (props, ref) => <MUIAlert elevation={2} ref={ref} variant="filled" {...props} />
);
